/**
 * URL-hash keys for the reception feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#delete/5`).
 */
export const RECEPTION_HASH = {
  /** `#scan` — camera QR scan dialog (listing). */
  scan: 'scan',
  /** `#delete/<id>` — single-shipment delete confirmation (listing). */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type ReceptionHashKey =
  (typeof RECEPTION_HASH)[keyof typeof RECEPTION_HASH];
